<template>
  <v-container>
    <v-app-bar app flat color="#0d1b2a" dark style="height: 64px;">
      <v-toolbar-title class="text-h5 toolbar-title" @click="$router.push('/')">
        Holonet Galactic Encyclopedia
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tabs align-with-title v-model="selectedTab">
        <v-tab to="/" :value="'home'">Home</v-tab>
        <v-menu>
          <template #activator="{ props }">
            <v-tab v-bind="props" :value="'planets'">Planets</v-tab>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in planetMenuItems" :key="index" :to="item.link">
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-tab to="/characters" :value="'characters'">Characters</v-tab>
        <v-tab to="/graphviewer" :value="'graphviewer'">Graph Viewer</v-tab>
        <v-menu>
          <template #activator="{ props }">
            <v-tab v-bind="props" :value="'data'">Access Data</v-tab>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in dataMenuItems" :key="index" :to="item.link">
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu>
          <template #activator="{ props }">
            <v-tab v-bind="props" :value="'hologames'">Hologames</v-tab>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in gameMenuItems" :key="index" :to="item.link">
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-tab to="/contribute" :value="'contribute'">Contribute</v-tab>
        <v-tab to="/roadmap" :value="'roadmap'">Roadmap</v-tab>
        <v-tab to="/about" :value="'about'">About</v-tab>
      </v-tabs>
    </v-app-bar>
  </v-container>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const selectedTab = ref('');
const planetMenuItems = ref([
  { name: "Atlas", link: "/planets/atlas" },
  { name: "Tab view", link: "/planets/table" }
]);
const gameMenuItems = ref([
  { name: "Stardle", link: "/games/stardle" },
  { name: "Holoword", link: "/games/holoword" }
  //,{ name: "Holopage", link: "/games/holopage" }
]);
const dataMenuItems = ref([
  { name: "Datasets", link: "/data/datasets" },
  { name: "SPARQL Queries", link: "/data/sparql" }
]);
// Update selectedTab based on current route
watch(
  () => route.path,
  (newPath) => {
    if (newPath.startsWith('/planets')) {
      selectedTab.value = 'planets';
    } else if (newPath.startsWith('/characters')) {
      selectedTab.value = 'characters';
    } else if (newPath.startsWith('/games')) {
      selectedTab.value = 'hologames';
    } else if (newPath.startsWith('/graphviewer')) {
      selectedTab.value = 'graphviewer';
    } else if (newPath.startsWith('/data')) {
      selectedTab.value = 'data';
    } else if (newPath.startsWith('/contribute')) {
      selectedTab.value = 'contribute';
    } else if (newPath.startsWith('/roadmap')) {
      selectedTab.value = 'roadmap';
    } else if (newPath.startsWith('/about')) {
      selectedTab.value = 'about';
    } else {
      selectedTab.value = 'home';
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.v-toolbar {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
}

.toolbar-title {
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1 auto;
  font-size: 1.25rem; /* Adjust font size as needed */
}
</style>
